import React from "react";
import { ROLES } from "../../config/roles";

const getKycBannerText = (role) => {
  switch (role) {
    case ROLES.Agent:
      return "Complete your account verification to start applying for pitches.";
    case ROLES.AgencyAdmin:
      return "Verify your agency account verification to start managing your agency.";
    case ROLES.ClubAdmin:
    case ROLES.Staff:
      return "Complete your account verification to start creating requests.";
    case ROLES.Player:
      return "Complete your account verification to start viewing your details.";
    default:
      return "Complete your account verification.";
  }
};

const KycVerificationBanner = ({
  currentRole,
  kycLoading,
  onVerifyAccount,
}) => {
  return (
    <div className="bg-[#FF2D55] text-white px-4 md:px-12 py-4 flex flex-col md:flex-row items-center justify-between mb-8 gap-4 md:gap-0">
      <p className="text-base md:text-xl font-normal text-center md:text-left">
        {getKycBannerText(currentRole)}
      </p>
      <button
        onClick={onVerifyAccount}
        disabled={kycLoading}
        className="flex items-center gap-2 border border-white bg-white/20 hover:bg-white/30 px-4 py-2 rounded-lg text-[#F5F5F5] w-full md:w-auto justify-center"
      >
        {kycLoading ? "Verifying..." : "Verify account"}
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.33398 5.99967H10.6673M10.6673 5.99967L6.00065 1.33301M10.6673 5.99967L6.00065 10.6663"
            stroke="#F5F5F5"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </div>
  );
};

export default KycVerificationBanner;
